 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"legal-ar-json":"legal-ar-json","legal-de-json":"legal-de-json","legal-en-json":"legal-en-json","legal-es-json":"legal-es-json","legal-fr-json":"legal-fr-json","legal-pt-json":"legal-pt-json","legal-ru-json":"legal-ru-json","legal-tr-json":"legal-tr-json","legal-ua-json":"legal-ua-json"}[chunkId]||chunkId) + "." + {"chunk-0bc2d2db":"8880fa36","chunk-0d83fbc2":"d76f82e9","chunk-18fdb127":"05b4996d","chunk-2d0e6355":"0642c7c5","chunk-2eb9965e":"717ea229","chunk-5b04599a":"2df6a355","chunk-1b4d2f37":"925e230d","chunk-1bd2f97a":"69c4da8a","chunk-247274cc":"ff4b9a26","chunk-2d0af0d9":"1f33beec","chunk-f65e948c":"4a05205a","chunk-27ce3904":"13b140b9","chunk-288fd533":"5df92c3a","chunk-16f3f6b0":"aa93fdc9","chunk-441cff8e":"24856f06","chunk-968d841a":"4ece453b","chunk-d9767892":"4a73de0e","chunk-2c2667d6":"a75c8aa8","chunk-2d0a4c28":"2063769e","chunk-415c8868":"17ca874d","chunk-464f6ed4":"db053c62","chunk-591b5c0d":"f403e991","chunk-9cc1261a":"cc503977","chunk-2d0c265d":"64466e82","chunk-2d0e8bf3":"c1b36440","chunk-5d4601d3":"455794b3","chunk-bb4de144":"11a3a7d2","chunk-2d213cd9":"75bd0673","chunk-2d2264f9":"c861d9aa","chunk-2d22bcc3":"4f39eb63","chunk-300de2e0":"20e8f135","chunk-3798d199":"230989ad","chunk-2d0b2ed7":"8302d419","chunk-48281b05":"8be88219","chunk-47c17ec4":"f8fc1255","chunk-5568dcee":"791598b2","chunk-37065fdb":"095f5b48","chunk-d9e8e1b6":"eef5ed1f","chunk-fb335286":"f63029af","chunk-2d0c554e":"91961465","chunk-2d0cc648":"1bc2bf32","chunk-2d22b9c1":"fee67191","chunk-2d230ff9":"211b1a64","chunk-556407f6":"c6de1c8e","chunk-5c123c0c":"1e2079fd","chunk-6384077e":"68127e76","chunk-7454f37e":"7762ab43","chunk-76b2896a":"c78e94f4","chunk-7b54520c":"38a48fe8","chunk-7cf1a974":"a47da95d","chunk-246e1a54":"50c5fcea","chunk-76f1791c":"b4d42ba1","chunk-7dd997c0":"47295328","chunk-f112342a":"24cdf71e","chunk-233a6f34":"053e4d41","chunk-2b376508":"e565dbf0","chunk-9fd6ce2a":"d575e372","chunk-2d0d6b43":"c43a1a12","chunk-70afea96":"f5464fe3","chunk-3e9945d8":"8268761e","chunk-2d21b46b":"2e862abd","chunk-36ba3ff5":"6c11fa31","chunk-145adf91":"b5bac9e7","chunk-4a528cf4":"94f7eb68","chunk-9a89c740":"965089a8","chunk-6d943556":"7ed84421","chunk-5b775630":"204fb64b","chunk-938a7e58":"acb8a01f","chunk-306a1924":"def39f57","chunk-2d0c45e9":"d692e4b2","chunk-44f5b6f4":"e1583816","chunk-6392a277":"5a01d6ef","chunk-440eb7a1":"1ee221e2","chunk-f77dcc66":"a4c32548","chunk-9ab49b8a":"ac9d2f5d","chunk-e587281c":"832e4c92","chunk-05f10b68":"b11347bd","chunk-4f1e02a6":"3a2ebec6","chunk-6b8807ea":"b7f68f1d","chunk-7dadfc54":"658449ac","chunk-b7e3a5b6":"b98a0a9f","chunk-3eedb40b":"4be9f391","chunk-7770eace":"a2c59300","chunk-36b109f5":"27d3ee7b","chunk-1729ccdd":"07495d2e","chunk-3aadd1f4":"d6d159e7","chunk-8184523e":"f006758b","chunk-874224fa":"7d22b558","chunk-930c66e8":"3e524dac","chunk-a9f7b4cc":"32221c07","chunk-b0c13b4e":"c7276457","chunk-c333f81c":"8679588f","chunk-ce51019c":"e533f511","chunk-d063668e":"bf6a6424","chunk-2d0bce45":"2389b87f","chunk-5eb33628":"1e3efb1a","chunk-d672e190":"f9b95654","chunk-52820531":"b9f14885","chunk-545b542b":"b07c235e","chunk-d9fd27a8":"38c70370","legal-ar-json":"d6a7b66c","legal-de-json":"2858a91e","legal-en-json":"4958a71b","legal-es-json":"9e10aa51","legal-fr-json":"01425381","legal-pt-json":"2e576e1b","legal-ru-json":"dab1df70","legal-tr-json":"d358ff0d","legal-ua-json":"c98f9581"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0bc2d2db":1,"chunk-0d83fbc2":1,"chunk-2eb9965e":1,"chunk-5b04599a":1,"chunk-1b4d2f37":1,"chunk-1bd2f97a":1,"chunk-247274cc":1,"chunk-27ce3904":1,"chunk-16f3f6b0":1,"chunk-441cff8e":1,"chunk-968d841a":1,"chunk-d9767892":1,"chunk-2c2667d6":1,"chunk-415c8868":1,"chunk-464f6ed4":1,"chunk-591b5c0d":1,"chunk-9cc1261a":1,"chunk-5d4601d3":1,"chunk-bb4de144":1,"chunk-300de2e0":1,"chunk-3798d199":1,"chunk-5568dcee":1,"chunk-37065fdb":1,"chunk-d9e8e1b6":1,"chunk-fb335286":1,"chunk-556407f6":1,"chunk-5c123c0c":1,"chunk-6384077e":1,"chunk-7454f37e":1,"chunk-76b2896a":1,"chunk-7b54520c":1,"chunk-7cf1a974":1,"chunk-f112342a":1,"chunk-233a6f34":1,"chunk-9fd6ce2a":1,"chunk-3e9945d8":1,"chunk-145adf91":1,"chunk-4a528cf4":1,"chunk-9a89c740":1,"chunk-6d943556":1,"chunk-5b775630":1,"chunk-938a7e58":1,"chunk-306a1924":1,"chunk-6392a277":1,"chunk-9ab49b8a":1,"chunk-05f10b68":1,"chunk-4f1e02a6":1,"chunk-6b8807ea":1,"chunk-7dadfc54":1,"chunk-b7e3a5b6":1,"chunk-3eedb40b":1,"chunk-7770eace":1,"chunk-36b109f5":1,"chunk-1729ccdd":1,"chunk-3aadd1f4":1,"chunk-8184523e":1,"chunk-874224fa":1,"chunk-930c66e8":1,"chunk-a9f7b4cc":1,"chunk-b0c13b4e":1,"chunk-c333f81c":1,"chunk-ce51019c":1,"chunk-d063668e":1,"chunk-d672e190":1,"chunk-52820531":1,"chunk-545b542b":1,"chunk-d9fd27a8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"legal-ar-json":"legal-ar-json","legal-de-json":"legal-de-json","legal-en-json":"legal-en-json","legal-es-json":"legal-es-json","legal-fr-json":"legal-fr-json","legal-pt-json":"legal-pt-json","legal-ru-json":"legal-ru-json","legal-tr-json":"legal-tr-json","legal-ua-json":"legal-ua-json"}[chunkId]||chunkId) + "." + {"chunk-0bc2d2db":"50ed836f","chunk-0d83fbc2":"0b1d0da3","chunk-18fdb127":"31d6cfe0","chunk-2d0e6355":"31d6cfe0","chunk-2eb9965e":"20b60b85","chunk-5b04599a":"65f1fd6f","chunk-1b4d2f37":"fbbb7c8d","chunk-1bd2f97a":"99f9bf7a","chunk-247274cc":"65f2d1d2","chunk-2d0af0d9":"31d6cfe0","chunk-f65e948c":"31d6cfe0","chunk-27ce3904":"69d2f66b","chunk-288fd533":"31d6cfe0","chunk-16f3f6b0":"b3888b7f","chunk-441cff8e":"a282f50f","chunk-968d841a":"8b611fad","chunk-d9767892":"e2efbe42","chunk-2c2667d6":"4a55fd3f","chunk-2d0a4c28":"31d6cfe0","chunk-415c8868":"fd79da1b","chunk-464f6ed4":"fd79da1b","chunk-591b5c0d":"fd79da1b","chunk-9cc1261a":"fd79da1b","chunk-2d0c265d":"31d6cfe0","chunk-2d0e8bf3":"31d6cfe0","chunk-5d4601d3":"ddb0c94d","chunk-bb4de144":"6105d055","chunk-2d213cd9":"31d6cfe0","chunk-2d2264f9":"31d6cfe0","chunk-2d22bcc3":"31d6cfe0","chunk-300de2e0":"1b0fcd18","chunk-3798d199":"8a57b68a","chunk-2d0b2ed7":"31d6cfe0","chunk-48281b05":"31d6cfe0","chunk-47c17ec4":"31d6cfe0","chunk-5568dcee":"80e7930a","chunk-37065fdb":"cbdc2f2e","chunk-d9e8e1b6":"d8a3a99e","chunk-fb335286":"16c2c5a1","chunk-2d0c554e":"31d6cfe0","chunk-2d0cc648":"31d6cfe0","chunk-2d22b9c1":"31d6cfe0","chunk-2d230ff9":"31d6cfe0","chunk-556407f6":"09808ccc","chunk-5c123c0c":"5be3ecf0","chunk-6384077e":"41043fdf","chunk-7454f37e":"1c451a83","chunk-76b2896a":"9401ae61","chunk-7b54520c":"4a3ee5b9","chunk-7cf1a974":"0f43ec39","chunk-246e1a54":"31d6cfe0","chunk-76f1791c":"31d6cfe0","chunk-7dd997c0":"31d6cfe0","chunk-f112342a":"bef5beda","chunk-233a6f34":"f96e4b40","chunk-2b376508":"31d6cfe0","chunk-9fd6ce2a":"e57d163e","chunk-2d0d6b43":"31d6cfe0","chunk-70afea96":"31d6cfe0","chunk-3e9945d8":"fde8ea19","chunk-2d21b46b":"31d6cfe0","chunk-36ba3ff5":"31d6cfe0","chunk-145adf91":"de1e028f","chunk-4a528cf4":"c07a6727","chunk-9a89c740":"d9019e28","chunk-6d943556":"3b5ac0c5","chunk-5b775630":"bef5beda","chunk-938a7e58":"c25668bd","chunk-306a1924":"0533a703","chunk-2d0c45e9":"31d6cfe0","chunk-44f5b6f4":"31d6cfe0","chunk-6392a277":"6165ca1b","chunk-440eb7a1":"31d6cfe0","chunk-f77dcc66":"31d6cfe0","chunk-9ab49b8a":"5af702d1","chunk-e587281c":"31d6cfe0","chunk-05f10b68":"2061c3d1","chunk-4f1e02a6":"e0c7211a","chunk-6b8807ea":"992f3a3e","chunk-7dadfc54":"700e68e6","chunk-b7e3a5b6":"e0c7211a","chunk-3eedb40b":"85e540f2","chunk-7770eace":"37225f02","chunk-36b109f5":"4c2347b1","chunk-1729ccdd":"191ddf0c","chunk-3aadd1f4":"16e1211c","chunk-8184523e":"4f0491b9","chunk-874224fa":"bf9024ca","chunk-930c66e8":"5332293e","chunk-a9f7b4cc":"a788f213","chunk-b0c13b4e":"4083c8ba","chunk-c333f81c":"b9a0d17b","chunk-ce51019c":"27f7f216","chunk-d063668e":"aa4eea43","chunk-2d0bce45":"31d6cfe0","chunk-5eb33628":"31d6cfe0","chunk-d672e190":"42e36982","chunk-52820531":"05c3d2f8","chunk-545b542b":"77ac5692","chunk-d9fd27a8":"990aeac6","legal-ar-json":"31d6cfe0","legal-de-json":"31d6cfe0","legal-en-json":"31d6cfe0","legal-es-json":"31d6cfe0","legal-fr-json":"31d6cfe0","legal-pt-json":"31d6cfe0","legal-ru-json":"31d6cfe0","legal-tr-json":"31d6cfe0","legal-ua-json":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
